import React from 'react';
import C from 'classnames';
import PropTypes from 'prop-types';

const Button = ({
  text,
  Icon,
  iconAlt,
  handleClick,
  fillBg,
  smallForPhone,
  ...rest
}) => (
  <button
    onClick={handleClick}
    className={C('main-button', {
      disabled: rest.disabled,
      'main-button--bg': fillBg,
      'small-for-phone': smallForPhone,
    })}
    {...rest}
  >
    <div className="main-button-text">{text}</div>
    {Icon && Icon}
  </button>
);

Button.defaultProps = {
  handleClick: () => {},
  fillBg: true,
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  fillBg: PropTypes.bool,
  smallForPhone: PropTypes.bool,
  Icon: PropTypes.object,
  iconAlt: PropTypes.string,
  handleClick: PropTypes.func,
};

export default Button;
